import React from 'react';

const CompletionCircle = ({ completedQuestions, totalQuestions }) => {
  // Calculate percentage, default to 0 if no questions
  const percentage = totalQuestions > 0 ? Math.round((completedQuestions / totalQuestions) * 100) : 0;
  
  // Calculate stroke dash offset for the progress circle
  const radius = 70;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference * (1 - (completedQuestions / (totalQuestions || 1)));

  return (
    <div className="flex justify-center">
      <div className="relative w-40 h-40">
        {/* Background circle */}
        <svg className="w-40 h-40 transform -rotate-90" viewBox="0 0 160 160">
          <circle
            cx="80"
            cy="80"
            r={radius}
            stroke="#e5e7eb"
            strokeWidth="7"
            fill="none"
          />
          {/* Progress circle */}
          <circle
            cx="80"
            cy="80"
            r={radius}
            stroke="#33C6B6"
            strokeWidth="7"
            fill="none"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            className="transition-all duration-500"
          />
        </svg>
        {/* Center content */}
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="text-4xl font-bold text-gray-900">
            {percentage}
            <span className="text-xl">%</span>
          </div>
          <div className="text-sm text-gray-600 mt-1">
            {completedQuestions}/{totalQuestions || 0}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompletionCircle;
